var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { useToggle } from '@hn-front/utils';
import { useEffect, useState } from 'react';
import { AddButton } from '../Buttons';
import { classLinkText, cleverText, } from '../Common';
import { AssistantRow } from './Rows/AssistantRows';
import { Header } from './Header';
import { Body } from './Common';
import { AddAssistantRow } from './Rows/AddAssistantRow';
import { InvitationSuccessModal } from './Modals/InvitationSuccessModal';
import { useAssistants } from '../hooks/useAssistants';
var columns = [
    {
        id: 0,
        name: '№',
    },
    {
        id: 1,
        name: 'Email',
    },
    {
        id: 2,
        name: 'Status',
    },
    {
        id: 3,
        name: null,
    },
];
var inviteInfoText = "We'll send an email to this address with instructions how\n  to join your class on Happy Numbers.";
var descriptionText = "You may add teacher assistant here and give them access to your class.";
var Container = styled.div.withConfig({ displayName: "Container", componentId: "sc-1o2jzkg" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n\n  color: ", ";\n"], ["\n  display: flex;\n  flex-direction: column;\n\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.black10;
});
var Title = styled.h2.withConfig({ displayName: "Title", componentId: "sc-b35bwn" })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-bottom: 8px;\n\n  font-feature-settings: 'clig' off, 'liga' off;\n  font-family: 'Noto Sans', sans-serif;\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 32px;\n"], ["\n  margin-bottom: 8px;\n\n  font-feature-settings: 'clig' off, 'liga' off;\n  font-family: 'Noto Sans', sans-serif;\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 32px;\n"])));
var Description = styled.div.withConfig({ displayName: "Description", componentId: "sc-1h7o1k6" })(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin-bottom: 24px;\n\n  font-family: 'Noto Sans', sans-serif;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 24px;\n"], ["\n  margin-bottom: 24px;\n\n  font-family: 'Noto Sans', sans-serif;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 24px;\n"])));
var Table = styled.div.withConfig({ displayName: "Table", componentId: "sc-xyu34c" })(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  margin-top: 8px;\n  margin-bottom: 24px;\n"], ["\n  margin-top: 8px;\n  margin-bottom: 24px;\n"])));
var InviteInfo = styled.p.withConfig({ displayName: "InviteInfo", componentId: "sc-wmuwx1" })(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  margin-top: 24px;\n\n  font-family: 'Noto Sans', sans-serif;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 24px;\n"], ["\n  margin-top: 24px;\n\n  font-family: 'Noto Sans', sans-serif;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 24px;\n"])));
var tooltipText = {
    clever: cleverText,
    class_link: classLinkText,
    manual: undefined,
};
var TeacherAssistantsTable = function (_a) {
    var groupData = _a.groupData, groupId = _a.groupId;
    var groupName = groupData.name, groupNumber = groupData.number, isAssistant = groupData.isAssistant;
    var _b = useToggle(), isInAddMode = _b.isToggled, toggleAddMode = _b.toggle;
    var _c = useToggle(), shouldShowModal = _c.isToggled, toggleModal = _c.toggle;
    var _d = useAssistants(groupId), assistants = _d.assistants, getAssistants = _d.getAssistants, inviteAssistant = _d.inviteAssistant, deleteAssistant = _d.deleteAssistant, captureError = _d.captureError;
    var _e = useState(''), newAssistantEmail = _e[0], setNewAssistantEmail = _e[1];
    var _f = useState(), validationErrors = _f[0], setValidationErrors = _f[1];
    var handleOnEmailChange = function (event) {
        setValidationErrors(undefined);
        setNewAssistantEmail(event.currentTarget.value);
    };
    var handleOnInvite = function (email) { return __awaiter(void 0, void 0, void 0, function () {
        var errors;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, inviteAssistant(email)];
                case 1:
                    errors = _a.sent();
                    setValidationErrors(errors);
                    if (!errors) {
                        toggleAddMode();
                        toggleModal();
                        setNewAssistantEmail('');
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var handleOnCancel = function () {
        toggleAddMode();
        setNewAssistantEmail('');
    };
    var shouldShowTable = assistants.length > 0 || isInAddMode;
    var shouldShowAddButton = !isAssistant && !isInAddMode;
    useEffect(function () {
        getAssistants();
    }, []);
    useEffect(function () {
        captureError();
    }, [captureError]);
    return (_jsxs(_Fragment, { children: [_jsxs(Container, { children: [_jsx(Title, { children: "Teacher assistants" }, void 0), shouldShowTable ? (_jsxs(Table, { children: [_jsx(Header, { columns: columns }, void 0), _jsxs(Body, { children: [assistants.map(function (assistant, index) { return (_jsx(AssistantRow, { index: index + 1, assistant: assistant, onDelete: deleteAssistant, groupName: groupName, groupNumber: groupNumber, tooltipText: tooltipText[assistant.locked_by ? assistant.locked_by : 'manual'] }, assistant.email)); }), isInAddMode && (_jsxs(_Fragment, { children: [_jsx(AddAssistantRow, { index: assistants.length + 1, validationErrors: validationErrors, email: newAssistantEmail, onEmailChange: handleOnEmailChange, onInvite: handleOnInvite, onCancel: handleOnCancel }, void 0), _jsx(InviteInfo, { children: inviteInfoText }, void 0)] }, void 0))] }, void 0)] }, void 0)) : (_jsx(Description, { children: descriptionText }, void 0)), shouldShowAddButton && (_jsx(AddButton, { title: 'Add teacher assistant', onClick: toggleAddMode }, void 0))] }, void 0), _jsx(InvitationSuccessModal, { isOpen: shouldShowModal, onClose: toggleModal }, void 0)] }, void 0));
};
export { TeacherAssistantsTable };
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
